// Mock data for Ahmet Murat Kadayıfçı Portfolio

export const personalInfo = {
  name: "Ahmet Murat Kadayıfçı",
  title: "Executive Search Consultant",
  tagline: "Connecting Organizations with Transformational Leaders | C-Level & Senior Executive Search",
  email: "ahmet.kadayifci@transearch.com",
  linkedin: "https://www.linkedin.com/in/ahmet-kadayifci-015143135/",
  location: "Istanbul, Turkey",
  photo: "/profile-photo.png",
  summary: "Executive Recruitment Associate at TRANSEARCH International, specializing in C-level and senior leadership placements across Fortune 500 and high-growth companies. Trusted partner for organizations seeking transformational executives who drive measurable business impact."
};

export const experience = [
  {
    id: 1,
    company: "TRANSEARCH International",
    role: "Executive Recruitment Associate",
    period: "January 2026 - Present",
    location: "Turkey",
    type: "current",
    description: "Managing end-to-end executive search processes, from role briefing and market mapping to shortlist delivery for C-level and senior leadership positions.",
    highlights: [
      "Manage end-to-end executive search processes, from role briefing and market mapping to shortlist delivery",
      "Conduct in-depth talent mapping and target company analysis for C-level and senior leadership positions across relevant industries",
      "Proactively source and approach senior executives using LinkedIn Recruiter and advanced research techniques",
      "Lead comprehensive candidate screening and in-depth interviews, assessing leadership competencies, career motivations, and cultural fit",
      "Prepare high-quality candidate profiles, assessment reports, and executive presentations for client review",
      "Work closely with Partners and Consultants to refine search strategies and ensure alignment with client expectations",
      "Act as a key point of contact for candidates, managing communication professionally throughout the recruitment process",
      "Maintain and regularly update candidate pipelines, CRM systems, and search tracking tools to ensure data accuracy",
      "Monitor market trends, competitor movements, and compensation benchmarks to provide strategic insights to search projects",
      "Support and guide Research Analysts or junior team members in sourcing and evaluation activities, when applicable"
    ]
  },
  {
    id: 2,
    company: "TRANSEARCH International",
    role: "Research Analyst",
    period: "August 2024 - December 2025",
    location: "Turkey",
    type: "past",
    description: "Contributed to executive search projects, conducting market research and candidate sourcing for senior-level positions.",
    highlights: [
      "Conducted market research to identify potential candidates for executive search projects",
      "Utilized LinkedIn Recruiter and advanced sourcing tools to build talent pipelines",
      "Analyzed resumes and profiles to assess candidate suitability for specific roles",
      "Engaged with candidates via email, phone, and LinkedIn to gauge interest and availability",
      "Collaborated with consultants and hiring managers to refine search strategies",
      "Prepared detailed reports and candidate presentations for client review",
      "Developed ATS system for HR professionals and recruiters (side project using Vibe)"
    ]
  },
  {
    id: 3,
    company: "Güven Çelik Machinery",
    role: "Sales Manager",
    period: "January 2020 - December 2021",
    location: "Turkey",
    type: "past",
    description: "Managed B2B sales operations for industrial machinery solutions, achieving consistent growth targets.",
    highlights: [
      "Conducted daily client visits to introduce industrial machinery solutions",
      "Developed strong relationships with key accounts and potential customers",
      "Prepared detailed Excel reports on sales performance and market analysis",
      "Negotiated contracts and closed deals to achieve annual targets"
    ]
  },
  {
    id: 4,
    company: "İstek Schools",
    role: "Gymnastics Instructor",
    period: "January 2019 - January 2020",
    location: "Sultangazi",
    type: "past",
    description: "Conducted gymnastics training sessions in accordance with federation standards.",
    highlights: [
      "Developed structured training programs for students",
      "Formed and coached performance groups for competitions",
      "Ensured safe training environment while promoting discipline and teamwork"
    ]
  },
  {
    id: 5,
    company: "Garanti Koza",
    role: "Athletic Performance Group Lead",
    period: "January 2017 - January 2019",
    location: "Bahçeşehir",
    type: "past",
    description: "Managed project-based training programs and coordinated student performance tracking.",
    highlights: [
      "Managed 6-month training programs for incoming students",
      "Conducted anthropometric measurements and performance assessments",
      "Created performance report cards and tracking systems"
    ]
  }
];

export const projects = [
  {
    id: 1,
    title: "AI-Powered ATS System",
    category: "AI & HR Technology",
    status: "Active",
    description: "Built with Vibe Coding - a comprehensive AI-powered Applicant Tracking System designed for HR professionals. Features intelligent candidate matching, automated screening, and AI-driven insights for recruitment optimization.",
    impact: "Actively used by HR professionals, reducing time-to-hire by streamlining AI-assisted candidate evaluation",
    technologies: ["Vibe Coding", "AI/ML", "Python", "React", "MongoDB", "OpenAI API"],
    features: [
      "AI-powered candidate matching and scoring",
      "Automated resume parsing with NLP",
      "Intelligent interview scheduling",
      "Predictive analytics for hiring success",
      "AI chatbot for candidate communication"
    ],
    year: "2026",
    note: "Vibe Coded Project"
  },
  {
    id: 2,
    title: "Executive Search Intelligence Platform",
    category: "AI & Business Intelligence",
    status: "In Development",
    description: "AI-driven market intelligence tool leveraging machine learning to analyze market trends, predict candidate availability, and provide competitive intelligence for executive positions.",
    technologies: ["Vibe Coding", "Python", "AI/ML", "LLM Integration", "Data Analytics"],
    features: [
      "Real-time market trend analysis",
      "AI-powered talent mapping",
      "Competitor intelligence automation",
      "Salary benchmarking with ML models"
    ],
    year: "2027",
    note: "Vibe Coded Project"
  },
  {
    id: 3,
    title: "Personal Portfolio Website",
    category: "Web Development",
    status: "Live",
    description: "Modern, responsive portfolio website built entirely with Vibe Coding methodology. Features dark theme design, QR code vCard integration, and seamless deployment.",
    technologies: ["Vibe Coding", "React", "TailwindCSS", "Vercel"],
    year: "2026",
    note: "Vibe Coded Project"
  }
];

export const skills = {
  executive: [
    { name: "Executive Search & Sourcing", level: 95 },
    { name: "Candidate Assessment", level: 90 },
    { name: "Market Research & Analysis", level: 92 },
    { name: "LinkedIn Recruiter", level: 95 },
    { name: "Client Relationship Management", level: 88 },
    { name: "Negotiation & Persuasion", level: 85 }
  ],
  technical: [
    { name: "Vibe Coding / AI Development", level: 90 },
    { name: "AI & LLM Integration", level: 85 },
    { name: "Python & Automation", level: 80 },
    { name: "React & Frontend Development", level: 75 },
    { name: "Prompt Engineering", level: 88 },
    { name: "AI-Powered Analytics", level: 82 }
  ],
  soft: [
    { name: "Communication & Networking", level: 95 },
    { name: "Problem Solving", level: 90 },
    { name: "Project Management", level: 85 },
    { name: "Team Leadership", level: 82 },
    { name: "Adaptability", level: 92 }
  ]
};

export const education = [
  {
    id: 1,
    institution: "İstanbul Gelişim Üniversitesi",
    degree: "Master's Degree",
    field: "Psychosocial Areas in Sports",
    period: "June 2020 - December 2022",
    type: "master"
  },
  {
    id: 2,
    institution: "Klaipeda University",
    degree: "Erasmus+ Student Mobility",
    field: "International Exchange Program",
    period: "2019 - 2020",
    location: "Lithuania",
    type: "exchange"
  },
  {
    id: 3,
    institution: "İstanbul Gelişim Üniversitesi",
    degree: "Bachelor's Degree",
    field: "Physical Education Teaching and Coaching",
    period: "2016 - 2020",
    type: "bachelor"
  }
];

export const certifications = [
  {
    id: 1,
    title: "Neuromarketing",
    icon: "Brain",
    description: "Advanced techniques in understanding consumer psychology and decision-making processes",
    category: "Marketing"
  },
  {
    id: 2,
    title: "Persuasion Techniques",
    icon: "MessageSquare",
    description: "Mastering influence and persuasion strategies in professional communication",
    category: "Communication"
  },
  {
    id: 3,
    title: "Strong Brand Building Strategies",
    icon: "Award",
    description: "Comprehensive brand development and positioning methodologies",
    category: "Marketing"
  },
  {
    id: 4,
    title: "Communication & Network Marketing",
    icon: "Users",
    description: "Effective networking and relationship-building techniques",
    category: "Communication"
  },
  {
    id: 5,
    title: "Diction Training",
    icon: "Mic",
    description: "Professional voice and speech techniques for effective presentations",
    category: "Communication"
  }
];

export const languages = [
  { name: "Turkish", level: "Native", proficiency: 100 },
  { name: "English", level: "Professional Working", proficiency: 85 }
];

export const stats = [
  { label: "Years Experience", value: "8+" },
  { label: "Executive Searches", value: "50+" },
  { label: "Industries Covered", value: "15+" },
  { label: "Client Projects", value: "20+" }
];
